














import Vue from 'vue'
import { GitLabPipelineDetails } from '@/interfaces'
import moment from 'moment'

export default Vue.extend({
  name: 'PipelineTile',
  props: {
    name: String,
    url: String,
    pipeline: Object as () => GitLabPipelineDetails,
  },
  computed: {
    displayName(): string {
      return this.breakOnUnderscore(this.name)
    },
  },
  methods: {
    breakOnUnderscore(str: string) {
      return str.split('_').map((word) => `<span>${word}</span>`).join('_')
    },
    pipelineDuration(pipeline: GitLabPipelineDetails) {
      if (pipeline.status === 'running') {
        const now = new Date()
        const started = new Date(pipeline.started_at || pipeline.created_at)
        const time = now.getTime() - started.getTime()
        return this.formatDuration(Math.floor(time / 1000))
      } else {
        return this.formatDuration(pipeline.duration)
      }
    },
    formatAge(dateStr: string) {
      const fromNow = moment(dateStr).fromNow()
      const message = fromNow.includes('seconds') ? 'Just now' : fromNow
      return message
    },
    formatDuration(time: number) {
      const minutes = Math.floor(time / 60)
      const seconds = time - minutes * 60
      const minutesStr = minutes > 1 ? 'minutes' : 'minute'
      const secondStr = seconds > 1 ? 'seconds' : 'second'
      return minutes > 0 ?
        `${minutes} ${minutesStr} ${seconds} ${secondStr}` :
        `${seconds} ${secondStr}`
    },
  },
})
